import { Injectable, type Type } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CosFeatureFlagsToolbarControlsSet extends Set<
  () => Promise<Type<unknown>>
> {
  addToPosition(position: number, item: () => Promise<Type<unknown>>) {
    if (position >= this.size) {
      this.add(item);
      return;
    }

    const existingItems = Array.from(this.values());

    this.clear();

    existingItems.forEach((existing, index) => {
      if (position === index) this.add(item);

      this.add(existing);
    });
  }
}
